<template>

    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>

            <v-flex xs12>
                <v-text-field
                        v-model="encrypt_key"
                        label="Encryption Key"
                        placeholder="Example: poop salad box lunch home"

                        v-on:input="calculateShift"
                ></v-text-field>
            </v-flex>

            <v-flex xs12>

                <v-textarea

                        v-model="encrypt_text"
                        name="encrypt_text"
                        label="Text to Encrypt"
                        placeholder="Type some salad box info here!"
                        auto-grow

                        prepend-inner-icon='delete'
                        :prepend-inner-icon-cb='clearDecryptedText'

                        append-icon='content_copy'
                        :append-icon-cb='copyDecrypted'
                ></v-textarea>

                <!--<v-textarea-->
                        <!--box-->
                        <!--v-model="encrypt_text"-->
                        <!--name="encrypt_text"-->
                        <!--label="Text to Encrypt"-->
                        <!--placeholder="Type some salad box info here!"-->
                        <!--v-on:input="onType"-->
                        <!--auto-grow-->
                <!--&gt;</v-textarea>-->

            </v-flex>

            <v-layout row justify-space-around>
                <v-flex xs2>
                    <v-btn v-on:click="onType">Encrypt
                        <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs2>
                    <v-btn v-on:click="decrypt">Decrypt
                        <v-icon>keyboard_arrow_up</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>

            <v-flex xs12>

                <v-textarea

                        v-model="encrypted_text"
                        name="encrypted_text"
                        label="Encrypted Text"
                        placeholder="Out comes the poop salad!"
                        auto-grow

                        prepend-inner-icon='delete'
                        :prepend-inner-icon-cb='clearEncryptedText'

                        append-icon='content_copy'
                        :append-icon-cb='copy'
                ></v-textarea>

            </v-flex>

            <v-layout row justify-space-around>
                <v-flex xs2>
                    <v-btn v-on:click="clearAll">Clear All
                        <v-icon>delete</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>


        </v-layout>


        <v-snackbar
                v-model="snackbar"
                :bottom="y === 'bottom'"
                :left="x === 'left'"
                :multi-line="mode === 'multi-line'"
                :right="x === 'right'"
                :timeout="timeout"
                :top="y === 'top'"
                :vertical="mode === 'vertical'"
        >
            {{ text }}
            <v-btn
                    color="pink"
                    flat
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>

    import KeiDecrypt from '@/assets/keidecrypt';


    export default {
        data() {
            return {
                debugmode: false,
                encrypt_text: '',
                encrypt_key: '',
                encrypted_text: '',
                possible_words: [
                    "salad",
                    "💩",
                    "slice",
                    "optimal",
                    "chicka",
                    "boop",
                    "1337",
                    "guys",
                    "potato",
                    "sauce",
                    "🧀",
                    "lunch",
                    "home",
                    "bread",
                    "👞",
                    "suboptimal"
                ],
                shifted_array: [],
                zerobits: [
                    "stuu",
                    "fuu",
                    "in",
                    "the",
                    "shinso",
                    "wutong",
                    "hoynoy",
                    "cuh" //energys contribution
                ],
                startchar: "hoynoy",
                endchar: "boxlunch",
                eight_zeroes: "🅱️",
                eight_zeroes_alt: ":b:",
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: 'multi-line',
                timeout: 2000,
                text: 'Hello, I\'m a snackbar'

            }
        },
        methods: {
            clearAll() {
              this.encrypted_text = ""
              this.encrypt_text = ""
              this.encrypt_key = ""
            },
            clearEncryptedText() {
              this.encrypted_text = ""
            },
            copy() {
              this.showSnack("Copied text!")
                let container = this.$refs.container
                this.$copyText(this.encrypted_text, container)
            },
            clearDecryptedText() {
                this.encrypt_text = ""
            },
            copyDecrypted() {
                this.showSnack("Copied text!")
                let container = this.$refs.container
                this.$copyText(this.encrypt_text, container)
            },
            showSnack(message) {
                this.text = message;
                this.snackbar  = true;
            },
            calculateShift() {

                var nums = 0;

                var numsstring = "";
                var code = 0;

                for (var i = 0; i < this.encrypt_key.length; i++) {
                    if (this.debugmode) console.log("PROCESS LETTER " + this.encrypt_text.charAt(i))
                    code += this.encrypt_key.charCodeAt(i);
                    nums = Math.floor(code / 10)
                    numsstring += String(Math.floor(code / 10))

                }


                this.shifted_array = []

                for (var numshifts = 0; numshifts < nums; numshifts++) {
                    this.shifted_array = JSON.parse(JSON.stringify(this.possible_words))
                    var word = this.shifted_array.shift();
                    this.shifted_array.push(word);
                }

                if (this.debugmode) console.log(this.shifted_array)
            },
            decrypt() {
                if(this.encrypt_key.length === 0){
                    this.showSnack("You must enter an encryption key salad!")
                    return;
                }

                if (this.encrypted_text.length === 0){
                    this.showSnack("You must enter text to decrypt!")
                    return;
                }

                var kc = new KeiDecrypt(this.encrypted_text);

                var decrypted = kc.decrypt(this.encrypt_key);

                //console.log(decrypted);
                this.encrypt_text = decrypted;

            },
            onType() {
                var length_text = this.encrypt_text.length

                var textarray = [];

                if(this.encrypt_key.length === 0){
                    this.showSnack("You must enter an encryption key salad!")
                    return;
                }

                if (length_text === 0){
                    this.showSnack("You must enter text to encrypt!")
                    return;
                }

                this.encrypted_text = '';

                var code;
                var binarized;

                var assign = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];

                if (this.debugmode) console.log("LENGTH " + length_text)

                for (var i = 0; i < length_text; i++) {
                    if (this.debugmode) console.log("PROCESS LETTER " + this.encrypt_text.charAt(i))
                    code = this.encrypt_text.charCodeAt(i);
                    binarized = Number(code).toString(2);
                    binarized = this.pad(binarized, 16)
                    if (this.debugmode) console.log(binarized);

                    assign[0] = binarized.charAt(0);
                    assign[1] = binarized.charAt(1);
                    assign[2] = binarized.charAt(2);
                    assign[3] = binarized.charAt(3);
                    assign[4] = binarized.charAt(4);
                    assign[5] = binarized.charAt(5);
                    assign[6] = binarized.charAt(6);
                    assign[7] = binarized.charAt(7);
                    assign[8] = binarized.charAt(8);
                    assign[9] = binarized.charAt(9);
                    assign[10] = binarized.charAt(10);
                    assign[11] = binarized.charAt(11);
                    assign[12] = binarized.charAt(12);
                    assign[13] = binarized.charAt(13);
                    assign[14] = binarized.charAt(14);
                    assign[15] = binarized.charAt(15);

                    //this.encrypted_text += this.startchar + " ";

                    var first8 = 0;
                    var k = 0;
                    for (var j = 0; j < 8; j++) {
                        first8 += Number(assign[j])
                    }

                    var not_shuffle = [];

                    if (first8 == 0) {
                        not_shuffle.push(this.eight_zeroes)
                        k = 8;
                    }


                    for (k; k < assign.length; k++) {
                        var val = assign[k]
                        if (this.debugmode) console.log(val)
                        if (val == 1) {
                            not_shuffle.push(this.shifted_array[k])
                        } else {
                            not_shuffle.push(this.zerobits[Math.floor(Math.random() * this.zerobits.length)])
                        }
                    }

                    var kc = new KeiDecrypt()

                    var shuffled = kc.shuffle(this.encrypt_key, not_shuffle);


                    textarray = textarray.concat(shuffled)
                    textarray.push(this.endchar);


                }
                this.encrypted_text = textarray.join(" ");
            },
            pad(n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            }
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
